var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chain-viewer',{attrs:{"list-of-certificates":_vm.certListSort}})
}
var staticRenderFns = []

export { render, staticRenderFns }